"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const types_1 = require("./types");
const errors_1 = require("./errors");
const presets_1 = require("./presets");
const tasks_1 = require("./tasks");
let Api = class Api {
    constructor(toolService, loggerService, configService, requireDriver, traceService, gulpSequence, toolPrefix) {
        traceService.track(this);
        this.toolService = toolService;
        this.loggerService = loggerService;
        this.configService = configService;
        this.requireDriver = requireDriver;
        this.gulpSequence = gulpSequence;
        this.toolPrefix = toolPrefix;
        this.tasks = {};
        Object.keys(tasks_1.toolNameByTaskName).forEach((taskName) => {
            Object.defineProperty(this.tasks, taskName, {
                enumerable: true,
                get() {
                    return toolService.getTool(tasks_1.toolNameByTaskName[taskName]);
                }
            });
        });
    }
    setupInMemoryTranspile() {
        const mochaToolPackageName = `${this.toolPrefix}mocha`;
        try {
            this.requireDriver.require(`${mochaToolPackageName}/dist/setup-file`);
        }
        catch (e) {
            this.loggerService.error(`Please install ${mochaToolPackageName} to use .setupInMemoryTranspile api`);
            throw e;
        }
    }
    getGlobalConfiguration() {
        return this.configService.getGlobalConfiguration();
    }
    setGlobalConfiguration(configuration) {
        return this.configService.setGlobalConfiguration(configuration);
    }
    getTool(toolName) {
        return this.toolService.getTool(toolName);
    }
    initializeTask(gulp, toolName, parameters) {
        this.toolService.getTool(toolName).register(gulp, toolName, parameters);
    }
    initializeTasks(gulp, parametersByToolName) {
        Object.keys(parametersByToolName).forEach(toolName => {
            this.initializeTask(gulp, toolName, parametersByToolName[toolName]);
        });
    }
    initializePreset(gulp, presetName, config) {
        let defaults;
        if (presets_1.presets.hasOwnProperty(presetName)) {
            defaults = presets_1.presets[presetName].filter((item) => {
                if (presets_1.presets.hasOwnProperty(item)) {
                    return true;
                }
                return gulp.tasks.hasOwnProperty(item);
            });
        }
        let taskNames;
        if (config === true && defaults) {
            taskNames = defaults;
        }
        else if (typeof config === 'function') {
            taskNames = config(defaults);
        }
        else if (Array.isArray(config)) {
            taskNames = config;
        }
        else {
            this.loggerService.error('Invalid preset configuration', config);
            throw new errors_1.InvalidUsage();
        }
        const currentSequence = this.gulpSequence.use(gulp);
        gulp.task(presetName, taskNames && taskNames.length ? currentSequence.apply(null, taskNames) : []);
    }
    initializePresets(gulp, configsByPresetName) {
        Object.keys(configsByPresetName).forEach(presetName => {
            this.initializePreset(gulp, presetName, configsByPresetName[presetName]);
        });
    }
    initialize(gulp, config) {
        const presetConfigsByPresetName = Object.keys(presets_1.presets).reduce((acc, presetName) => (Object.assign({}, acc, { [presetName]: true })), {});
        Object.keys(config).forEach((taskOrPresetName) => {
            const parameters = config[taskOrPresetName];
            const isTool = tasks_1.toolNameByTaskName.hasOwnProperty(taskOrPresetName);
            if (parameters === false) {
                delete presetConfigsByPresetName[taskOrPresetName];
            }
            else if (isTool) {
                const toolName = tasks_1.toolNameByTaskName[taskOrPresetName];
                this.toolService.getTool(toolName).register(gulp, toolName, parameters);
            }
            else {
                presetConfigsByPresetName[taskOrPresetName] = parameters;
            }
        });
        Object.keys(presetConfigsByPresetName).forEach((presetName) => {
            this.initializePreset(gulp, presetName, presetConfigsByPresetName[presetName]);
        });
    }
};
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Api.prototype, "setupInMemoryTranspile", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Api.prototype, "getGlobalConfiguration", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "setGlobalConfiguration", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], Api.prototype, "getTool", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String, Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "initializeTask", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "initializeTasks", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String, Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "initializePreset", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "initializePresets", null);
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Api.prototype, "initialize", null);
Api = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(types_1.TYPE_TOOL_SERVICE)),
    __param(1, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_LOGGER)),
    __param(2, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_CONFIG)),
    __param(3, inversify_1.inject(types_1.TYPE_DRIVER_REQUIRE)),
    __param(4, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_TRACE)),
    __param(5, inversify_1.inject(urbanjs_tools_core_1.TYPE_DRIVER_GULP_SEQUENCE)),
    __param(6, inversify_1.inject(types_1.TYPE_CONFIG_TOOL_PREFIX)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, String])
], Api);
exports.Api = Api;
